// @ts-nocheck
import { Layout, Menu, Tooltip } from "antd";
import Sider from "antd/lib/layout/Sider";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import "./appSidebar.scss";
import { Pages } from "pages";
import { getSelectedTab, isRouteChild } from "./query";
import { TMenuItem } from "./types";
import Icon from "atoms/icons/icon";
import SubMenu from "antd/lib/menu/SubMenu";
import { Link } from "react-router-dom";
import "antd/dist/antd.css";
import { useLocation } from "react-router";
import StackItem from "molecules/stackItem/stackItem";
import Stack from "molecules/stack/stack";
import SheetBody from "atoms/sheet/sheetBody/sheetBody";
import Sheet from "atoms/sheet/sheet";
import { isLoggedOut } from "models/subscriptions/selector";
import Modal from "antd/lib/modal/Modal";
import {
  SignInButton,
  SignOutButton,
} from "molecules/authentication/authentication";
import Label from "atoms/label/label";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserData } from "models/user/sagaActions";
import { hasNetworkError } from "models/subscriptions/selector";
import {
  getWebAppSettings,
  isAclDataRestrictionsReadEnabled,
  isAclRolesReadEnabled,
  isAclUsersReadEnabled,
  isAdvertisingRead,
  isAllOrdersRead,
  isAppAliasSettingRead,
  isAppSettingEnabled,
  isAvailabilityRead,
  isCreateOrderRead,
  isDemandChangeRead,
  isDemandReportingRead,
  isForecast,
  isIntelligenceRead,
  isMasterDataAdTypesRead,
  isMasterDataCustomersRead,
  isMasterDataGroupsRead,
  isMasterDataPresentationQuantityReadEnabled,
  isMasterDataRead,
  isMasterDataShipmentsRead,
  isMasterDataShippingMethodsRead,
  isMasterDataStoreOrderListRead,
  isMasterDataStoresRead,
  isMasterDataValidSkuItemCombinationsRead,
  isMasterDataValidStoreSkuCombinationsRead,
  isMatrix,
  isOrderItemsRead,
  isOrderKitsRead,
  isOrderSkusRead,
  isParametersRead,
  isPlanogramRestrictionsReadEnabled,
  isReplenishmentRead,
  isMasterDataInventoryTransactionsRead,
  isMasterDataKitsRead,
  isMasterDataItemShippingMethodConfigurationRead,
  isMasterDataItemExclusionsRead,
  isMasterDataItemsRead,
  isRaUploadReadWriteDelete,
  isMasterDataRetailSalesReadWriteEnabled,
  isAimRead,
  isReportRead,
  isMasterDataWarehouseReadWrite,
  isOrderPivotReadWrite
} from "models/user/selector";
import { getMsalInstance } from "utils/msalInstance";
import { isLoadingEnabled } from "models/loaders/selectors";
import { AppLoading } from "appLoading";
import { fetchTableColumns } from "models/tableColumns/sagaActions";
import { useColumnAliasName } from "hooks/useColumnAliasName";
import { UPLOAD_MODEL_ID } from "pages/masterData/constants";
import { forcastRequest } from "authConfig";
import { ReportingUrl } from "models/user/constants";

interface Props extends React.PropsWithChildren<any> {
  isExpanded?: boolean;
}

const getRoutesDir: () => TMenuItem[] = (state, webAppSettings) => {
  return [
    createMenuItem(
      100,
      "Order Writing",
      "/",
      "Theta",
      "icon-dashboard",
      !isReplenishmentRead(state),
      [
        createMenuItem(101, "Home", "/", "Theta", "icon-dashboard"),
        createMenuItem(
          102,
          "Orders",
          "/orders",
          "Orders",
          "icon-order",
          !isAllOrdersRead(state) &&
            !isOrderItemsRead(state) &&
            !isOrderSkusRead(state) &&
            !isOrderKitsRead(state),
          [
            createMenuItem(
              1,
              "Create an Order",
              "/create",
              null,
              null,
              !isCreateOrderRead(state) && !isCreateOrderRead(state)
            ),
            createMenuItem(
              2,
              "All Orders",
              "/orders?selectedTab=all",
              null,
              null,
              !isAllOrdersRead(state)
            ),
            createMenuItem(
              3,
              "Order Kits",
              "/orders?selectedTab=kits",
              null,
              null,
              !isOrderKitsRead(state)
            ),
            createMenuItem(
              4,
              "Order SKUs",
              "/orders?selectedTab=skus",
              null,
              null,
              !isOrderSkusRead(state)
            ),
            createMenuItem(
              5,
              "Order Items",
              "/orders?selectedTab=items",
              null,
              null,
              !isOrderItemsRead(state)
            ),
            createMenuItem(
              6,
              "Order Pivot",
              "/orders?selectedTab=pivot",
              null,
              null,
              !isOrderPivotReadWrite(state)
            ),

            createMenuItem(
              7,
              "Oders details",
              "/orders/details/:id",
              null,
              null,
              true
            ),
          ]
        ),
        createMenuItem(
          104,
          "Advertising",
          "/advertising",
          "Advertising",
          "icon-dashboard",
          !isAdvertisingRead(state)
        ),
        createMenuItem(
          103,
          "Availability",
          "/availability",
          "Inventory",
          "icon-dashboard",
          !isAvailabilityRead(state)
        ),

        createMenuItem(
          105,
          "Parameters",
          "/parameters",
          "Inventory",
          "icon-dashboard",
          !isParametersRead(state)
        ),
        // createMenuItem(106, "Demand Planning", "/demand-planning", "DemandPlanningSvg", "icon-dashboard",
        //   !webAppSettings?.IsDemandPlanning ||
        //   (!isDemandChangeRead(state) &&
        //     !isDemandGroupHubRead(state) &&
        //     !isDemandReportingRead(state)), [
        //   createMenuItem(15, "Demand Reporting", "/demand-planning?selectedTab=reporting", null, null, !isDemandReportingRead(state)),
        //   createMenuItem(16,
        //     "Demand Change",
        //     "/demand-planning?selectedTab=matrix", null, null,
        //     !isDemandChangeRead(state),),
        //   createMenuItem(17,
        //     "Demand Group Hub",
        //     "/demand-planning/hub", null, null,
        //     !isDemandChangeRead(state),),
        // ]),
        createMenuItem(
          107,
          "Planogram",
          "/planogram",
          "faCartPlus",
          "icon-dashboard",
          !isPlanogramRestrictionsReadEnabled(state),
          [
            createMenuItem(
              19,
              "Planogram Attributes",
              "/planogram/attributes",
              !isDemandReportingRead(state),
              "Orders"
            ),
            createMenuItem(
              20,
              "Listing",
              "/planogram/list",
              !isDemandChangeRead(state),
              "Orders"
            ),
          ]
        ),
      ]
    ),
    createMenuItem(
      200,
      "Intelligence",
      "/intelligence",
      "Theta",
      "icon-reporting",
      !isIntelligenceRead(state),
    ),
    createMenuItem(
      300,
      "AIM",
      "https://aim.demandlink.com/Home/Login",
      "Theta",
      "icon-aim",
      !isAimRead(state)
    ),
    createMenuItem(
      400,
      "RA Upload",
      "/raupload",
      "Theta",
      "icon-ra-upload",
      !isRaUploadReadWriteDelete(state)
    ),
    createMenuItem(
      500,
      "Lowe's Forecast",
      forcastRequest,
      "Theta",
      "icon-forecast",
      !isForecast(state)
    ),
    createMenuItem(
      600,
      "Matrix",
      "http://lowesmatrix.com/",
      "Theta",
      "icon-matrix",
      !isMatrix(state)
    ),
createMenuItem(
      600,
      "Reporting",
       ReportingUrl,
      "Reporting",
      "icon-report",
      !isReportRead(state)
    ),
    createMenuItem(
      800,
      "Master Data",
      "/masterdata",
      "Theta",
      "icon-master-data",
      !isMasterDataRead(state),
      [
        createMenuItem(
          801,
          "Ad Types",
          "/masterdata/adTypes",
          "Theta",
          "icon-dashboard",
          !isMasterDataAdTypesRead(state)
        ),
        createMenuItem(
          802,
          "Customers",
          "/masterdata/customers",
          "Customers",
          "icon-dashboard",
          !isMasterDataCustomersRead(state)
        ),
        createMenuItem(
          803,
          "Groups",
          "/masterdata/groups",
          "Groups",
          "icon-dashboard",
          !isMasterDataGroupsRead(state)
        ),
        createMenuItem(
          804,
          "Transactions",
          "/masterdata/transactions",
          "Transactions",
          "icon-dashboard",
          !isMasterDataInventoryTransactionsRead(state)
        ),
        createMenuItem(
          805,
          "Item Exclusions",
          "/masterdata/excludestoreitem",
          "Theta",
          "icon-dashboard",
          !isMasterDataItemExclusionsRead(state)
        ),
        createMenuItem(
          806,
          "Item Shipping Method Configuration",
          "/masterdata/shipmethoditemconfig",
          "Customers",
          "icon-dashboard",
          !isMasterDataItemShippingMethodConfigurationRead(state)
        ),
        createMenuItem(
          807,
          "Items",
          "/masterdata/items",
          "Groups",
          "icon-dashboard",
          !isMasterDataItemsRead(state)
        ),
        createMenuItem(
          808,
          "Kits",
          "/masterdata/kits",
          "Transactions",
          "icon-dashboard",
          !isMasterDataKitsRead(state)
        ),
        createMenuItem(
          809,
          "Parameters",
          "/masterdata/parameterview",
          "Groups",
          "icon-dashboard",
          !isMasterDataGroupsRead(state)
        ),
        createMenuItem(
          810,
          "Pricing",
          "/masterdata/storeskucost",
          "Transactions",
          "icon-dashboard",
          !isAclDataRestrictionsReadEnabled(state)
        ),
        createMenuItem(
          811,
          "SKU Exclusions",
          "/masterdata/excludestoresku",
          "Theta",
          "icon-dashboard",
          !isMasterDataAdTypesRead(state)
        ),
        createMenuItem(
          812,
          "Primary Store SKU",
          "/masterdata/primaryStoreSku",
          "Primary Store SKU",
          "icon-dashboard",
          !isMasterDataCustomersRead(state)
        ),
        createMenuItem(
          813,
          "SKUs",
          "/masterdata/skus",
          "SKUs",
          "icon-dashboard",
          !isMasterDataAdTypesRead(state)
        ),
        createMenuItem(
          814,
          "Schedules",
          "/masterdata/storeschedules",
          "Store Schedules",
          "icon-dashboard",
          !isMasterDataCustomersRead(state)
        ),
        createMenuItem(
          815,
          "Shipments",
          "/masterdata/shipments",
          "Shipments",
          "icon-dashboard",
          !isMasterDataShipmentsRead(state)
        ),
        createMenuItem(
          816,
          "Ship Methods",
          "/masterdata/shipmethods",
          "Shipmethods",
          "icon-dashboard",
          !isMasterDataShippingMethodsRead(state)
        ),
        createMenuItem(
          817,
          "Store Order List",
          "/masterdata/store/order/list",
          "Store Order List",
          "icon-dashboard",
          !isMasterDataStoreOrderListRead(state)
        ),
        createMenuItem(
          818,
          "Stores",
          "/masterdata/stores",
          "Stores",
          "icon-dashboard",
          !isMasterDataStoresRead(state)
        ),
        createMenuItem(
          819,
          "Valid SKU/Item Combinations",
          "/masterdata/skuitemmapping",
          "Valid SKU/Item Combinations",
          "icon-dashboard",
          !isMasterDataValidSkuItemCombinationsRead(state)
        ),
        createMenuItem(
          820,
          "Valid Store/SKU Combinations",
          "/masterdata/storesku",
          "Valid Store/SKU Combinations",
          "icon-dashboard",
          !isMasterDataValidStoreSkuCombinationsRead(state)
        ),
        createMenuItem(
          821,
          "Warehouse",
          "/masterdata/warehouses",
          "Warehouse",
          "icon-dashboard",
          !isMasterDataWarehouseReadWrite(state)
        ),
        createMenuItem(
          822,
          "Presentation Quantity",
          "/masterdata/presentation-quantity",
          "Presentation Quantity",
          "icon-dashboard",
          !isMasterDataPresentationQuantityReadEnabled(state)
        ),
        createMenuItem(
          823,
          "Retail Sales",
          "/masterdata/retail-sales",
          "Retail Sales",
          "icon-dashboard",
          !isMasterDataRetailSalesReadWriteEnabled(state)
        ),
      ]
    ),
    createMenuItem(
      700,
      "App Settings",
      "/settings",
      "Theta",
      "icon-app-settings",
      !isAppSettingEnabled(state),
      [
        createMenuItem(
          701,
          "Column Aliases",
          "/settings/columnaliases",
          "Theta",
          "icon-dashboard",
          !isAppAliasSettingRead(state)
        ),
        createMenuItem(
          702,
          "Roles",
          "/settings/roles",
          "Roles",
          "icon-dashboard",
          !isAclRolesReadEnabled(state)
        ),
        createMenuItem(
          703,
          "App Users",
          "/settings/users",
          "Users",
          "icon-dashboard",
          !isAclUsersReadEnabled(state)
        ),
        createMenuItem(
          704,
          "App Data Restrictions",
          "/settings/restrictions",
          "Users",
          "icon-dashboard",
          !isAclDataRestrictionsReadEnabled(state)
        ),
      ]
    ),
  ];
};

function createMenuItem(
  id,
  displayName,
  Route,
  imgAlias = null,
  faAliasName = null,
  isDisabled = false,
  children = [],
  settings?: boolean
) {
  return {
    id,
    displayName,
    Route,
    imgAlias,
    faAliasName,
    isDisabled,
    ...(children.length > 0 && { children }),
    ...(settings !== undefined && { settings }),
  };
}
const matchRoute = (routePath, path) => {
  if (!routePath || !path) return false; // Ensure both are valid strings

  const routeSegments = routePath.split("/").filter(Boolean);
  const pathSegments = path.split("/").filter(Boolean);

  if (routeSegments.length !== pathSegments.length) return false;

  return routeSegments.every(
    (seg, i) => seg.startsWith(":") || seg === pathSegments[i]
  );
};

const getActiveRoute = (routes, path) => {
  if (!Array.isArray(routes) || !path) return null; // Ensure inputs are valid

  for (const route of routes) {
    if (!route?.Route) continue;

    if (route.Route === path || matchRoute(route.Route, path)) {
      return route; // Direct or parameterized match found
    }

    if (Array.isArray(route.children) && route.children.length > 0) {
      const foundChild = route.children.find(
        (child) =>
          child?.Route &&
          (child.Route === path || matchRoute(child.Route, path))
      );
      if (foundChild) {
        return route; // Return the parent, not the child
      }

      // Recursively check deeper levels
      const foundNestedParent = getActiveRoute(route.children, path);
      if (foundNestedParent) {
        return route; // Return the highest-level parent
      }
    }
  }
  return null; // No matching parent found
};

const AppSidebar: React.FunctionComponent<Props> = (props: Props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchTableColumns(UPLOAD_MODEL_ID));
  }, [dispatch]);
  const isLoadingUserSettings = useSelector((state) =>
    isLoadingEnabled(state, "user-data-loading")
  );
  const getAliasName = useColumnAliasName(UPLOAD_MODEL_ID);

  const webAppSettings = useSelector(getWebAppSettings);
  const routesDir = useSelector((state) =>
    getRoutesDir(state, webAppSettings, 12)
  ).map((res) => ({
    ...res,
    children: res?.children?.map((c) => ({
      ...c,
      displayName: getAliasName(c.displayName),
    })),
  }));

  const routeChild = isRouteChild(
    routesDir,
    `${window.location.pathname}${window.location.search}`
  );
  const isLoggedOutUser: any = useSelector((state) => isLoggedOut(state));
  const isNetworkError = useSelector((state) => hasNetworkError(state));
  const activeLink = React.useMemo(
    () => getActiveRoute(routesDir, location.pathname),
    [location.pathname, routesDir]
  );
  const [selectedTab, updateSelectedTab] = useState<number>(
    getSelectedTab(
      activeLink?.children ?? [],
      `${location.pathname}${location.search}`
    )
  );
  const msalInstance = getMsalInstance();

  const [isChildRoute, toggleChildRoute] = useState<boolean>(routeChild);
  const [isSidebarOpen, toggleSideBar] = useState<boolean>(false);
  const [isChildMenuOpen, toggleChildMenu] = useState<boolean>(
    false || routeChild
  );
  const routes = _.filter(_.flatten(Pages), (route) =>
    Boolean(route.component)
  );

  const checkUserAvailability = msalInstance.getAllAccounts();

  const isHidden = checkUserAvailability.length <= 0;
const [openKeys, setOpenKeys] = useState([]);


  useEffect(() => {
    if (props.isAuthenticated && !isLoggedOutUser) {
      dispatch(fetchUserData());
    }
  }, [dispatch, isLoggedOutUser, props.isAuthenticated]);

useEffect(() => {
  const currentPath = location.pathname + location.search;

  const findParent = (items) => {
    for (const item of items) {
      if (item.children?.length) {
        // child match found → return parent id
        const childMatch = item.children.some(child =>
          matchRoute(child.Route, currentPath)
        );
        if (childMatch) return item.id.toString();

        // recursive for deep nesting
        const deep = findParent(item.children);
        if (deep) return deep;
      }
    }
    return null;
  };

  const parentKey = findParent(routesDir);

  if (parentKey) {
    setOpenKeys([parentKey]); 
  }
}, [location.pathname, location.search]);


  useEffect(() => {
    const test = _.filter(routes, (route) => {
      if (
        location?.pathname?.match("orders/details") &&
        route?.path?.match("orders/details")
      ) {
        return true;
      } else if (
        location?.pathname?.match("planogram/details") &&
        route?.path?.match("planogram/details")
      ) {
        return true;
      }
      return route.path.toLowerCase() === location.pathname.toLowerCase();
    });

    document.title = test[test?.length - 1]?.title;
  }, [location]);

  const handleClick = React.useCallback(
    (e: React.MouseEvent, id: number, path: string) => {
      updateSelectedTab(id);
      // cancelOngoingRequests();
      dispatch(fetchUserData());
      if (selectedTab !== id) {
        toggleChildMenu(false);
      }
      toggleChildRoute(isRouteChild(routesDir, path));
      //   history.push(path);
      //   e.stopPropagation();
    },
    [toggleChildRoute, toggleChildMenu]
  );

  // if (isLoadingUserSettings && !isLoggedOutUser) {
  // 	return null
  // }

  if (isHidden) {
    return null;
  }

const handleOpenChange = (keys) => {
  setOpenKeys(keys);
};

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {isLoadingUserSettings && !isLoggedOutUser ? (
        <AppLoading />
      ) : (
        isLoggedOutUser && (
          <div
            style={{
              width: "100%",
              height: "100%",
              position: "fixed",
              top: 0,
              left: 0,
              // zIndex: 1000,
            }}
          >
            <Modal
              centered
              visible
              closable={false}
              maskClosable={false}
              footer={null}
              className="modal-invalid-user"
            >
              <Sheet>
                <SheetBody>
                  <Stack
                    gutter="medium"
                    isVertical
                    align="center"
                    position="center"
                  >
                    <StackItem>
                      <Icon imgAlias="ThetaLogoDark" size="large" />
                    </StackItem>
                    <StackItem position="center">
                      {isNetworkError ? (
                        <Label>
                          Network Error, please reconnect and sign in to
                          continue.
                        </Label>
                      ) : (
                        <Label>
                          {checkUserAvailability.length ? (
                            <div style={{ display: "block" }}>
                              Hi {checkUserAvailability[0].username}, it looks
                              like you don't have access to Skulicity yet.If you
                              believe this is an error, please email
                              <a href="mailto:help@skulicity.com">
                                {" "}
                                help@skulicity.com
                              </a>{" "}
                              for assistance.
                            </div>
                          ) : (
                            <>
                              Your session has expired. Please log in again to
                              continue.
                            </>
                          )}
                        </Label>
                      )}
                    </StackItem>
                    <StackItem position="center">
                      {checkUserAvailability.length ? (
                        <SignOutButton />
                      ) : (
                        <SignInButton />
                      )}
                    </StackItem>
                  </Stack>
                </SheetBody>
              </Sheet>
            </Modal>
          </div>
        )
      )}
      <Sider
        className={`custom-sidenav ${
          !(activeLink?.children && activeLink?.children?.length) &&
          `mini-sidebar`
        }`}
        width={270}
        collapsible
         collapsed={
          isSidebarOpen
        }
        onCollapse={() => {
          toggleSideBar(!isSidebarOpen);
        }}
            >
        {/* <div className="logo" /> */}
        <Sheet isSidebar>
          <SheetBody isTransparent>
            <Stack isVertical>
              <StackItem
                align="center"
                isStretch
                position="center"
                className="main-logo"
              >
                {isSidebarOpen ||
                !(activeLink?.children && activeLink?.children?.length) ? (
                  // <Icon imgAlias="Theta" size="medium" />
                  <Icon imgAlias="SmallLogo" size="medium" />
                ) : (
                  <Icon imgAlias="NavFooterLogo" size="large" />
                )}
              </StackItem>
              <StackItem isGrow>
                <Stack
                  isVertical
                  gutter="small"
                  position="center"
                  align="center"
                >
                  <StackItem isStretch className="nav-list-wrapper">
                    <div className="nav-list-main">
                      <div className="main-nav-items">
                        {_.map(routesDir, (route, index) => {
                          const isExternal = route?.Route?.startsWith("http");
                          if (route?.isDisabled) return;
                          if (isExternal) {
                            return (
                              <Tooltip
                                title={route.displayName}
                                placement="right"
                              >
                                <a
                                  href={route.Route}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={`main-nav-item`}
                                >
                                  <div style={{display:"contents"}}>
                                    <div className="nav-img">
                                    <i className={route.faAliasName} />
                                    </div>
                                  <p className="sidebar-text">{route.displayName}</p>                                 
                                  </div>
                                  <div className="nav-text">
                                    {route.displayName}
                                  </div>
                                </a>
                              </Tooltip>
                            );
                          }
                          let href = route.Route;
                          if (
                            !route?.Route &&
                            route.children &&
                            route.children.length > 0
                          ) {
                            href = route.children[0].Route;
                          }
                          return (
                            <React.Fragment key={route.id}>
                              {index === routesDir.length - 2 && (
                                <hr className="nav-hr" />
                              )}

                            <Link
                                to={href}
                                className={`main-nav-item ${
                                  activeLink?.id === route.id ? "active" : ""
                                }`}
                              >
                                  
                                <Tooltip
                                  title={route.displayName}
                                  placement="right"> 
                                <div style={{display:"contents"}}>
                                    <div className="nav-img">
                                    <i className={route.faAliasName} />
                                    </div>
                                  <p className="sidebar-text">{route.displayName}</p>                                 
                                  </div>
                                <div className="nav-text">
                                  {route.displayName}
                                </div></Tooltip>
                              </Link> 
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </div>
                    {activeLink?.children && activeLink?.children?.length && (
                      <div className="nav-list-sub">
                        <div className="main-title">
                          {activeLink?.displayName}
                        </div>
                        <Menu
                          className="nav-list-block activelink-menu"
                          // defaultSelectedKeys={[
                          //   activeLink?.key?.toString(),
                          //   selectedTab.toString(),
                          // ]}
                          // defaultOpenKeys={[
                          //   activeLink?.key?.toString(),
                          //   selectedTab.toString(),
                          // ]}
                         selectedKeys={[activeLink?.key?.toString(), selectedTab.toString()]}
                          openKeys={openKeys}
                          onOpenChange={handleOpenChange}

                          mode="inline"
                        >
                          {_.map(
                            _.sortBy(activeLink?.children, (route) => {
                              if (
                                activeLink.Route === "/masterdata" ||
                                activeLink.Route === "/settings"
                              ) {
                                return route.displayName?.toLowerCase();
                              }
                              return 0;
                            }),
                            (route, index) => {
                              return (
                                !route?.isDisabled &&
                                (route.children ? (
                                  <SubMenu
                                    className={`nav-icon`}
                                    icon={
                                      (route?.imgAlias || route.faAlias) && (
                                        <div>
                                          <i className={route.faAliasName} />
                                        </div>
                                      )
                                    }
                                    key={route.id}
                                    title={route.displayName}
                                  >
                                    {_.map(
                                      route.children,
                                      (cRoute, innerIndex) =>
                                        !cRoute?.isDisabled && (
                                          <Menu.Item
                                            className={`nav-icon ${
                                              `${location.pathname}${location.search}` ===
                                              cRoute.Route
                                                ? "ant-menu-item-active"
                                                : ""
                                            } `}
                                            onClick={(e) =>
                                              handleClick(
                                                e,
                                                cRoute.id,
                                                cRoute.Route
                                              )
                                            }
                                            key={cRoute.id}
                                            icon={
                                              cRoute.imgAlias && cRoute.id!==19 && (
                                                <div>
                                                  <i
                                                    className={
                                                      route.faAliasName
                                                    }
                                                  />
                                                </div>
                                              )
                                            }
                                          >
                                            <Link to={cRoute.Route}>
                                              {cRoute.displayName}
                                            </Link>
                                          </Menu.Item>
                                        )
                                    )}
                                  </SubMenu>
                                ) : (
                                  <Menu.Item
                                    className={
                                      location.pathname === route.Route
                                        ? "ant-menu-item-active"
                                        : ""
                                    }
                                    onClick={(e) =>
                                      handleClick(e, route.id, route.Route)
                                    }
                                    key={route.id}
                                    icon={
                                      (route?.imgAlias || route.faAlias) && (
                                        <div>
                                          <i className={route.faAliasName} />
                                        </div>
                                      )
                                    }
                                  >
                                    <Link to={route.Route}>
                                      {route.displayName}
                                    </Link>
                                  </Menu.Item>
                                ))
                              );
                            }
                          )}
                        </Menu>
                      </div>
                    )}
                  </StackItem>
                </Stack>
              </StackItem>
            </Stack>
          </SheetBody>
        </Sheet>
      </Sider>
    </Layout>
  );
};

const defaultProps: Props = {
  isExpanded: false,
};

AppSidebar.defaultProps = defaultProps;

export default AppSidebar;
